import React from "react";
import { ErrorBoundary } from "react-error-boundary";

const myErrorHandler = (error, info) => {
  console.error("Error caught by Error Boundary: ", error, info);
};

const ErrorFallback = ({ error }) => {
  return (
    <div role="alert" style={styles.container}>
      <h1 style={styles.header}>Oops! Something went wrong.</h1>
      <p style={styles.message}>
        An unexpected error has occurred. Please try again later.
      </p>
      <p style={styles.details}>{error.message}</p>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f8d7da",
    color: "#721c24",
    textAlign: "center",
  },
  header: {
    fontSize: "36px",
    marginBottom: "20px",
  },
  message: {
    fontSize: "24px",
    marginBottom: "20px",
  },
  details: {
    fontSize: "16px",
    color: "#d94855",
  },
};

export { ErrorBoundary, ErrorFallback, myErrorHandler };
